import React, {useRef, useEffect, useContext, useState} from "react";
import {unmountComponentAtNode} from "react-dom";
import validateEmail from "../functions/validateEmail";
import {GlobalContext} from "../contexts/Provider";
import {send} from "../contexts/actions/form/send";

const CareerForm = () => {

    const {
        state: {
            sent,
            sending,
            careerId
        },
        dispatch
    } = useContext(GlobalContext);

    const [fileName, setFileName] = useState("VYBERTE SÚBOR (vo formáte .rtf, .doc, .pdf)");

    const allowedExtensions = /(\.doc|\.docx|\.odt|\.pdf|\.rtf)$/i;

    const contactForm = useRef(null);
    const name = useRef(null);
    const phone = useRef(null);
    const email = useRef(null);
    const message = useRef(null);
    const gdpr = useRef(null);
    const file = useRef(null);

    useEffect(() => {
        if (sent) {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
                'event': 'careerFormSubmit',
            });
            contactForm.current.reset();
        }
    }, [sent]);

    const validFile = () => {
        let setFile = file.current.files[0];
        if (!setFile || !allowedExtensions.exec(setFile.name)) {
            file.current.value = "";
            file.current.parentElement.classList.add('error');
            setFileName("VYBERTE SÚBOR (vo formáte .rtf, .doc, .pdf)");
            return false;
        }
        return true;
    }

    const handleChangeFile = () => {
        let setFile = file.current.files[0];
        if (validFile()) {
            setFileName(setFile.name);
            file.current.parentElement.classList.remove('error');
        }
    };

    const handleSubmit = async (event) => {

        event.preventDefault();
        name.current.parentElement.classList.remove('error');
        email.current.parentElement.classList.remove('error');
        message.current.parentElement.classList.remove('error');
        phone.current.parentElement.classList.remove('error');
        gdpr.current.parentElement.classList.remove('error');

        let valid = true;
        if (name.current.value == '') {
            name.current.parentElement.classList.add('error');
            valid = false;
        }
        if (!validateEmail(email.current.value)) {
            email.current.parentElement.classList.add('error');
            valid = false;
        }
        if (phone.current.value == '') {
            phone.current.parentElement.classList.add('error');
            valid = false;
        }

        if (message.current.value == '') {
            message.current.parentElement.classList.add('error');
            valid = false;
        }

        if (!gdpr.current.checked) {
            gdpr.current.parentElement.classList.add('error');
            valid = false;
        }

        if (!validFile()) {
            valid = false;
        }

        if (!valid) {
            return false;
        }

        const formData = new FormData(event.target);
        formData.append('career_id', careerId);

        send({
            formData,
            url: '/api/career-form'
        })(dispatch)

    }

    const truncate = (source, size) => {
        return source.length > size ? source.slice(0, size - 1) + "…" : source;
    }

    const handleClose = () => {
        document.body.classList.remove('open-career-form');
        unmountComponentAtNode(document.getElementById('career-form'));
    }


    return (
        <>
            <button className="career-form__close" onClick={handleClose}><img src="/images/icon-close-gray.svg"
                                                                              alt="" /></button>
            <div className="contact-form__header">
                <h3>POŠLITE NÁM SVOJ ŽIVOTOPIS</h3>
            </div>
            <form method="post" onSubmit={handleSubmit} ref={contactForm}>
                <div className="contact-form__body">
                    <div className="form-group">
                        <input placeholder="&nbsp;" ref={name} id="name" name="name" className="form-control"
                               type="text" />
                        <label className="form-label" htmlFor="name">MENO A PRIEZVISKO *</label>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 sm:gap-4">
                        <div className="form-group">
                            <input placeholder="&nbsp;" ref={email} id="email" name="email" className="form-control"
                                   type="text" />
                            <label className="form-label" htmlFor="email">EMAIL *</label>
                        </div>
                        <div className="form-group mt-8 sm:mt-0">
                            <input placeholder="&nbsp;" ref={phone} id="phone" name="phone" className="form-control"
                                   type="text" />
                            <label className="form-label" htmlFor="phone">TELEFÓN *</label>
                        </div>
                    </div>

                    <div className="form-group">
                        <textarea ref={message} placeholder="&nbsp;" name="message" id="content"
                                  className="form-control" />
                        <label className="form-label" htmlFor="content">TEXT SPRÁVY *</label>
                    </div>

                    <div className="form-group upload-file">
                        <label htmlFor="file">
                            {truncate(fileName, 50)}
                            <span>VYBRAŤ</span>
                        </label>
                        <input onChange={handleChangeFile} ref={file} type="file" name="file" id="file" />
                    </div>

                    <div className="form-group contact-form__gdpr">
                        <label htmlFor="gdpr">
                            <input id="gdpr" type="checkbox" name="gdpr" ref={gdpr} />
                            <svg xmlns="http://www.w3.org/2000/svg" width="22.5" height="22.5"
                                 viewBox="0 0 22.5 22.5">
                                <g id="icon_checked" transform="translate(0.75 0.75)">
                                    <path id="Path_263" data-name="Path 263"
                                          d="M298.138,551.523l-3.853,4.46-2.371-1.913"
                                          transform="translate(-284.577 -542.771)" fill="none" stroke="#ebebeb"
                                          strokeLinecap="square" strokeWidth="1.5" />
                                    <circle id="Ellipse_2" data-name="Ellipse 2" cx="10.5" cy="10.5" r="10.5"
                                            fill="none" stroke="#ebebeb" strokeLinecap="square"
                                            strokeWidth="1.5" />
                                </g>
                            </svg>
                            <span>Súhlasím so spracovaním a ochranou <a href={window.privacyUrl} target="_blank">Osobných údajov</a> pre potreby spoločnosti. Tieto údaje nebudú šírené tretím osobám.</span>
                        </label>
                    </div>
                    <div>
                        <button className="btn btn-secondary"
                                disabled={sending}>{sending ? "Odosielam..." : "Odoslať"}</button>
                    </div>
                </div>
            </form>
            {sent &&
                <section className="form-message animated fadeIn go">
                    <div className="form-message__content">
                        <img src="/images/icon-checked-green.svg" alt="" />
                        <h3>
                            Vaša správa bola úspešne odoslaná.
                        </h3>
                        <p className="text-center">
                            v čo najkratšom čase vás <br /> budeme kontaktovať
                        </p>
                    </div>
                </section>
            }
        </>
    );

}


export default CareerForm;
